import ky from "ky";

import { http } from "./api.services";
import { decryptData } from "~/utils/crypto";
export async function getRoleBasedPermissions(role: string) {
  try {
    // const url = new URL(process.env.VITE_AWS_ROLE_PERMISSIONS_URL!);
    // const params = new URLSearchParams();
    // params.append("roleid", role);
    // url.search = params.toString();
    const data = await http
      .put(process.env.VITE_AWS_ROLE_PERMISSIONS_URL! + "?roleid=" + role, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .json();

    return { status: true, data };
  } catch (e: any) {
    console.error(e);
    return {
      status: false,
      message: e.message,
    };
  }
}

export async function updateLogoutTime() {
  try {
    // const url = new URL(process.env.VITE_AWS_ROLE_UPDATE_LOGOUT_URL!);
    // const params = new URLSearchParams();
    const roleid = localStorage.getItem("roleid") as string;
    // params.append("roleid", roleid);
    // url.search = params.toString();
    const data = await http
      .put(`${process.env.VITE_AWS_ROLE_UPDATE_LOGOUT_URL}?roleid=${roleid}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .json();

    return { status: true, data };
  } catch (e: any) {
    console.error(e);
    return {
      status: false,
      message: e.message,
    };
  }
}

export async function getTokens(authCode: string) {
  try {
    const params = new URLSearchParams();
    params.append("grant_type", "authorization_code");
    params.append("client_id", process.env.VITE_AWS_COGNITO_CLIENT_ID!);
    params.append("code", authCode);
    params.append("redirect_uri", process.env.VITE_AWS_COGNITO_REDIRECT_URL!);
    const data = await ky
      .post(`${process.env.VITE_AWS_COGNITO_URL}/oauth2/token`, {
        searchParams: params,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .json();
    return { status: true, data };
  } catch (error: any) {
    return {
      status: false,
      message: error.message,
    };
  }
}
export async function getNewTokens() {
  console.log("getNewTokens called at:", new Date().toISOString());
  try {
    // Get refresh token from localStorage
    const refreshTokenEncrypted = localStorage.getItem("refresh_token");
    if (!refreshTokenEncrypted) {
      console.error("No refresh token found in localStorage");
      return {
        status: false,
        message: "No refresh token available",
      };
    }

    // Decrypt refresh token
    let refreshToken;
    try {
      refreshToken = decryptData(refreshTokenEncrypted);
    } catch (decryptError) {
      console.error("Failed to decrypt refresh token:", decryptError);
      return {
        status: false,
        message: "Invalid refresh token",
      };
    }

    // Prepare request to token endpoint
    const url = new URL(process.env.VITE_AWS_COGNITO_URL + "/oauth2/token");
    const params = new URLSearchParams();
    params.append("grant_type", "refresh_token");
    params.append("client_id", process.env.VITE_AWS_COGNITO_CLIENT_ID!);
    params.append("refresh_token", refreshToken);

    url.search = params.toString();

    // Send request
    const response = await ky.post(url, {
      headers: { "content-type": "application/x-www-form-urlencoded" },
      timeout: 10000, // 10 second timeout
      retry: 2, // Retry twice on failure
    });

    // Handle error response
    if (!response.ok) {
      const errorText = await response.text();
      console.error("Token refresh failed:", response.status, errorText);
      return {
        status: false,
        message: `Token refresh failed: ${response.status}`,
      };
    }

    // Parse response data
    const data = (await response.json()) as Record<string, any>;

    // If we have an id_token, parse it to get the iat claim
    if (data.id_token) {
      try {
        const tokenParts = (data.id_token as string).split(".");
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));

          // Get the expiry time directly from the token
          const expiryTime = payload["exp"];

          if (expiryTime) {
            // Store the expiry time in localStorage
            localStorage.setItem("token_expiry", expiryTime.toString());
            console.log(
              "Token refresh successful, new expiry:",
              new Date(expiryTime * 1000).toISOString(), // Convert seconds to milliseconds
              "Raw timestamp:",
              expiryTime
            );
          }
        }
      } catch (error) {
        console.error("Error parsing token payload:", error);
        // Continue with the response even if parsing fails
      }
    }

    return { status: true, data };
  } catch (error: any) {
    console.error("Error refreshing token:", error);
    return {
      status: false,
      message: error.message || "Unknown error refreshing token",
    };
  }
}
